import * as braze from '@braze/web-sdk';
import { BRAZE_ENABLE, BRAZE_ENDPOINT, BRAZE_LOG_DEBUGGING, BRAZE_SDK_KEY } from 'config/env';

let brazeInitialized = false;

export const isBrazeInitialized = (): boolean => brazeInitialized;

export const initBraze = (): void => {
  if (brazeInitialized || !BRAZE_ENABLE) return;

  braze.enableSDK();
  braze.initialize(BRAZE_SDK_KEY ?? '', {
    baseUrl: BRAZE_ENDPOINT ?? '',
    enableLogging: BRAZE_LOG_DEBUGGING ?? false,
    allowUserSuppliedJavascript: true,
    requireExplicitInAppMessageDismissal: true,
  });
  braze.automaticallyShowInAppMessages();
  brazeInitialized = true;
};
